import { RadialProgress, Text, TextColor, TextSize } from '@vizit/atoms';
import * as React from 'react';

const EXTENDED_MESSAGE_DELAY = 30000; // 30 seconds
/**
 * Loading state component for Spark
 * Displays while Spark recommendations are being curated
 * Shows different messages after 30 seconds
 */
export const SparkLoading = () => {
  const [showExtendedMessage, setShowExtendedMessage] = React.useState(false);

  React.useEffect(() => {
    const timer = setTimeout(() => {
      setShowExtendedMessage(true);
    }, EXTENDED_MESSAGE_DELAY);

    return () => clearTimeout(timer);
  }, []);

  return (
    <div className="flex flex-col justify-start items-center h-full text-center gap-8 lg:justify-center">
      <RadialProgress isIndeterminate size={32} aria-label="Loading Spark recommendations" />

      <div className="flex flex-col gap-4">
        <Text size={TextSize.Lg} color={TextColor.Secondary}>
          {showExtendedMessage ? 'Still thinking...' : 'Hang tight!'}
        </Text>

        <div className="flex flex-col gap-2">
          <Text size={TextSize.Lg} maxLines={10} color={TextColor.Secondary}>
            {showExtendedMessage ? (
              <>Feel free to navigate away and check back.</>
            ) : (
              <>
                We're curating your Spark recommendations.
                <br />
                <br />
                This may take up to 2 minutes.
              </>
            )}
          </Text>
        </div>
      </div>
    </div>
  );
};
